import React from "react";
import { Line } from "rc-progress";

const Goals = () => {
  return (
    <div className="border border-secondary rounded-lg px-4 pt-4 pb-1 shadow-sm">
      <h5 className="">Lorem ipsum dolor sit, amet consectetur adipisicing.</h5>
      <div className="d-flex align-items-center">
        <Line percent={80} strokeWidth={3} strokeColor="#D3D3D3" />
        <h3 className="ml-4">10%</h3>
      </div>
    </div>
  );
};

export default Goals;
